
export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4 font-nunito">
              Dépannage Urgent Électricité
            </h3>
            <p className="text-gray-300 mb-4 font-nunito">
              Artisan électricien à Nantes depuis plus de 30 ans. 
              Interventions d'urgence 7j/7 pour particuliers et professionnels.
            </p>
            <div className="flex items-center text-red-400">
              <i className="ri-phone-line mr-2"></i>
              <a href="tel:+33656847324" className="font-semibold cursor-pointer font-nunito">06 56 84 73 24</a>
            </div>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="font-bold mb-4 font-nunito">Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="font-nunito">Dépannage urgent</li>
              <li className="font-nunito">Mise aux normes</li>
              <li className="font-nunito">Tableau électrique</li>
              <li className="font-nunito">Rénovation électrique</li>
            </ul>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 font-nunito">Liens rapides</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#accueil" className="hover:text-red-400 transition-colors cursor-pointer font-nunito">Accueil</a></li>
              <li><a href="#services" className="hover:text-red-400 transition-colors cursor-pointer font-nunito">Services</a></li>
              <li><a href="#garanties" className="hover:text-red-400 transition-colors cursor-pointer font-nunito">Garanties</a></li>
              <li><a href="#contact" className="hover:text-red-400 transition-colors cursor-pointer font-nunito">Contact</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm font-nunito">
              © 2024 Dépannage Urgent Électricité - Nantes | 
              <span className="mx-2">SIRET : 75269522100016</span>
            </p>
            <div className="flex flex-wrap gap-6">
              <a href="#" className="text-gray-400 hover:text-red-400 text-sm transition-colors cursor-pointer font-nunito">
                Politique de confidentialité
              </a>
            </div>
          </div>
          
          <div className="text-center mt-6 pt-4 border-t border-gray-700">
            <p className="text-gray-400 text-xs font-nunito">
              Vous aussi, créez votre site web avec Stas au 07 67 11 79 48
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
